module.exports = {"540302100":"城关镇","540302101":"俄洛镇","540302102":"卡若镇","540302200":"芒达乡","540302201":"沙贡乡","540302202":"若巴乡","540302203":"埃西乡","540302204":"如意乡","540302205":"日通乡","540302206":"柴维乡","540302207":"妥坝乡","540302208":"嘎玛乡","540302209":"面达乡","540302210":"约巴乡","540302211":"拉多乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540302.json
// module id = 2509
// module chunks = 0